import type { FC, ReactNode } from "react";
import { useMemo } from "react";

import { ApiClient } from "./ApiClient";
import { ApiClientContext } from "./ApiClientContext";
import { client as transport, clientLeifGPT as transportLeifGPT, clientV2 as transportV2 } from "./AxiosClient";

interface ApiClientProviderProps {
  children: ReactNode;
}

export const ApiClientProvider: FC<ApiClientProviderProps> = ({ children }) => {
  const client = useMemo(() => new ApiClient(transport, transportV2, transportLeifGPT), []);

  return <ApiClientContext.Provider value={client}>{children}</ApiClientContext.Provider>;
};
